<div class="automation-rule-condition-form">
  <form [formGroup]="form">
    <div formArrayName="conditions">
      <ng-container
        *ngFor="
          let conditionControl of conditionsFormArray?.controls;
          trackBy: trackByControlValue;
          let i = index
        "
      >
        <!-- <div
          *ngIf="conditionControl?.value?.logicalOperator"
          class="custom-divider"
        >
          <span class="cursor-pointer" [matMenuTriggerFor]="menu">
            {{ conditionControl?.value?.logicalOperator }}
          </span>

          <mat-menu class="lum-mat-menu" #menu="matMenu">
            <button mat-menu-item (click)="onLogicalOperatorChange(i, logicalOperators.AND)">
              AND
            </button>
            <button mat-menu-item (click)="onLogicalOperatorChange(i, logicalOperators.OR)">
              OR
            </button>
          </mat-menu>
        </div> -->

        <div *ngIf="i !== 0" class="custom-divider mt-4"></div>

        <div class="flex">
          <div
            class="conditions-form__content flex-grow-1 gap-4"
            [formGroupName]="i"
          >
            <div class="form-group w-p20">
              <div class="lum-label">Conditions</div>
              <mat-select
                class="lum-select"
                formControlName="condition"
                [ngClass]="{
                  error:
                    conditionControl.get('condition')?.invalid &&
                    conditionControl.get('condition')?.touched,
                }"
              >
                <mat-option
                  *ngFor="let condition of filteredConditions; trackBy: trackById"
                  [value]="condition.id"
                  (click)="onSelectCondition(condition.id, i)"
                >
                  {{ condition.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form?.get('condition')?.invalid">
                <small>
                  {{ form?.get('condition') | validateField }}
                </small>
              </mat-error>
            </div>

            <ng-container [ngSwitch]="conditionControl?.value?.condition">
              <!-- Boolean Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.BOOLEAN"
                formGroupName="boolean"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Field</div>
                  <mat-select
                    class="lum-select"
                    formControlName="field"
                    [ngClass]="{
                      error:
                        conditionControl.get('boolean')?.get('field')?.invalid &&
                        conditionControl.get('boolean')?.get('field')?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="let field of isTrueFalseFieldList; trackBy: trackById"
                      [value]="field.id"
                    >
                      {{ field.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="form-group w-p20">
                  <div class="lum-label">Value</div>
                  <mat-select
                    class="lum-select"
                    formControlName="value"
                    [ngClass]="{
                      error:
                        conditionControl.get('boolean')?.get('value')?.invalid &&
                        conditionControl.get('boolean')?.get('value')?.touched,
                    }"
                  >
                    <mat-option value="true"> True </mat-option>
                    <mat-option value="false"> False </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="conditionControl.get('boolean')?.get('value')?.invalid"
                  >
                    <small>
                      {{
                        conditionControl.get('boolean')!.get('value')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
              </ng-container>

              <!-- Date Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.DATE"
                formGroupName="date"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Field</div>
                  <mat-select
                    class="lum-select"
                    formControlName="field"
                    [ngClass]="{
                      error:
                        conditionControl.get('date')?.get('field')?.invalid &&
                        conditionControl.get('date')?.get('field')?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="let field of hasDateFieldList; trackBy: trackById"
                      [value]="field.id"
                    >
                      {{ field.name }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    class="lum-select"
                    formControlName="operator"
                    [ngClass]="{
                      error:
                        conditionControl.get('date')?.get('operator')?.invalid &&
                        conditionControl.get('date')?.get('operator')?.touched,
                    }"
                  >
                    <mat-option value="before">Before</mat-option>
                    <mat-option value="after">After</mat-option>
                    <mat-option value="between">Between</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="conditionControl.get('date')?.get('operator')?.invalid"
                  >
                    <small>
                      {{
                        conditionControl.get('date')!.get('operator')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>

                <ng-container formGroupName="value">
                  <div
                    *ngIf="
                      conditionControl?.value?.date?.operator === 'between';
                      else singleDatePicker
                    "
                    class="flex gap-4 w-100"
                  >
                    <div class="form-group w-p20">
                      <div class="lum-label">Start</div>
                      <mat-form-field class="lum-datepicker-field w-100">
                        <input
                          matInput
                          [matDatepicker]="startDatepicker"
                          formControlName="start"
                          [ngClass]="{
                            error:
                              conditionControl
                                .get('date')
                                ?.get('value')
                                ?.get('start')?.invalid &&
                              conditionControl
                                .get('date')
                                ?.get('value')
                                ?.get('start')?.touched,
                          }"
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="startDatepicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #startDatepicker></mat-datepicker>
                      </mat-form-field>
                      <mat-error
                        *ngIf="
                          conditionControl.get('date')?.get('value')?.get('start')
                            ?.invalid
                        "
                      >
                        <small>
                          {{
                            conditionControl.get('date')!.get('value')!.get('start')
                              | validateField
                          }}
                        </small>
                      </mat-error>
                    </div>

                    <div class="form-group w-p20">
                      <div class="lum-label">End</div>
                      <mat-form-field class="lum-datepicker-field w-100">
                        <input
                          matInput
                          [matDatepicker]="endDatepicker"
                          formControlName="end"
                          [ngClass]="{
                            error:
                              conditionControl.get('date')?.get('value')?.get('end')
                                ?.invalid &&
                              conditionControl.get('date')?.get('value')?.get('end')
                                ?.touched,
                          }"
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="endDatepicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #endDatepicker></mat-datepicker>
                      </mat-form-field>
                      <mat-error
                        *ngIf="
                          conditionControl.get('date')?.get('value')?.get('end')
                            ?.invalid
                        "
                      >
                        <small>
                          {{
                            conditionControl.get('date')!.get('value')!.get('end')
                              | validateField
                          }}
                        </small>
                      </mat-error>
                    </div>
                  </div>

                  <ng-template #singleDatePicker>
                    <div class="form-group w-p20">
                      <div class="lum-label">Value</div>
                      <mat-form-field class="lum-datepicker-field w-100">
                        <input
                          matInput
                          [matDatepicker]="orderDatepicker"
                          formControlName="start"
                          [ngClass]="{
                            error:
                              conditionControl
                                .get('date')
                                ?.get('value')
                                ?.get('start')?.invalid &&
                              conditionControl
                                .get('date')
                                ?.get('value')
                                ?.get('start')?.touched,
                          }"
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="orderDatepicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #orderDatepicker></mat-datepicker>
                      </mat-form-field>
                      <mat-error
                        *ngIf="
                          conditionControl.get('date')?.get('value')?.get('start')
                            ?.invalid
                        "
                      >
                        <small>
                          {{
                            conditionControl.get('date')!.get('value')!.get('start')
                              | validateField
                          }}
                        </small>
                      </mat-error>
                    </div>
                  </ng-template>
                </ng-container>
              </ng-container>

              <!-- Item Count Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.ITEM_COUNT"
                formGroupName="itemCount"
              >
                <div class="form-group w-p20">
                  <div class="lum-label">Min Count</div>
                  <input
                    class="lum-input"
                    formControlName="minCount"
                    type="number"
                    [ngClass]="{
                      error:
                        conditionControl.get('itemCount')?.get('minCount')
                          ?.invalid &&
                        conditionControl.get('itemCount')?.get('minCount')?.touched,
                    }"
                  />
                  <mat-error
                    *ngIf="
                      conditionControl.get('itemCount')?.get('minCount')?.invalid
                    "
                  >
                    <small>
                      {{
                        conditionControl.get('itemCount')!.get('minCount')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
              </ng-container>

              <!-- Aggregate Relationship Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.AGGREGATE_RELATIONSHIP"
                formGroupName="aggregateRelationship"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Relationship</div>
                  <mat-select
                    class="lum-select"
                    formControlName="relation"
                    [ngClass]="{
                      error:
                        conditionControl.get('aggregateRelation')?.get('relation')
                          ?.invalid &&
                        conditionControl.get('aggregateRelation')?.get('relation')
                          ?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="
                        let relation of automationRuleConfig.aggregateRelations;
                        trackBy: trackById
                      "
                      [value]="relation.id"
                    >
                      {{ relation.name }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="form-group w-p20">
                  <div class="lum-label">Aggregation Type</div>
                  <mat-select
                    class="lum-select"
                    formControlName="aggregationType"
                    [ngClass]="{
                      error:
                        conditionControl
                          .get('aggregateRelation')
                          ?.get('aggregationType')?.invalid &&
                        conditionControl
                          .get('aggregateRelation')
                          ?.get('aggregationType')?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="
                        let type of automationRuleConfig.aggregateTypes;
                        trackBy: trackById
                      "
                      [value]="type.id"
                    >
                      {{ type.name }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="form-group w-p20">
                  <div class="lum-label">Attritbute</div>
                  <mat-select
                    class="lum-select"
                    formControlName="attribute"
                    [ngClass]="{
                      error:
                        conditionControl.get('aggregateRelation')?.get('attribute')
                          ?.invalid &&
                        conditionControl.get('aggregateRelation')?.get('attribute')
                          ?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="let field of fieldList; trackBy: trackById"
                      [value]="field.id"
                    >
                      {{ field.name }}
                    </mat-option>
                  </mat-select>
                </div>
              </ng-container>

              <!-- Has Not Performed Action Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.HAS_NOT_PERFORMED_ACTION"
                formGroupName="hasNotPerformedAction"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Rule</div>
                  <mat-select
                    class="lum-select"
                    formControlName="ruleId"
                    [ngClass]="{
                      error:
                        conditionControl.get('hasNotPerformedAction')?.get('ruleId')
                          ?.invalid &&
                        conditionControl.get('hasNotPerformedAction')?.get('ruleId')
                          ?.touched,
                    }"
                  >
                    <mat-option [value]="null">
                      Current rule hasn't run yet
                    </mat-option>
                    <mat-option
                      *ngFor="let rule of ruleIds; trackBy: trackById"
                      [value]="rule.id"
                    >
                      {{ rule.name }}
                    </mat-option>
                  </mat-select>
                </div>
              </ng-container>

              <!-- Has Tag Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.HAS_TAG"
                formGroupName="hasTag"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Field</div>
                  <mat-select
                    class="lum-select"
                    formControlName="relationPath"
                    [ngClass]="{
                      error:
                        conditionControl.get('hasTag')?.get('relationPath')
                          ?.invalid &&
                        conditionControl.get('hasTag')?.get('relationPath')
                          ?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="let field of hasTagFieldList; trackBy: trackById"
                      [value]="field.id"
                    >
                      {{ field.name }}
                    </mat-option>
                  </mat-select>
                </div>

                <div class="form-group w-p20">
                  <div class="lum-label">Tag</div>
                  <mat-select
                    class="lum-select"
                    formControlName="tag"
                    [ngClass]="{
                      error:
                        conditionControl.get('hasTag')?.get('tag')?.invalid &&
                        conditionControl.get('hasTag')?.get('tag')?.touched,
                    }"
                  >
                    <mat-option *ngFor="let tag of tags" [value]="tag.label">
                      {{ tag.label }}
                    </mat-option>
                  </mat-select>
                </div>
              </ng-container>

              <!-- Text Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.TEXT"
                formGroupName="text"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Field</div>
                  <mat-select
                    class="lum-select"
                    formControlName="field"
                    [ngClass]="{
                      error:
                        conditionControl.get('text')?.get('field')?.invalid &&
                        conditionControl.get('text')?.get('field')?.touched,
                    }"
                  >
                    <mat-option
                      *ngFor="let field of fieldList; trackBy: trackById"
                      [value]="field.id"
                    >
                      {{ field.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    class="lum-select w-100"
                    formControlName="operator"
                    [ngClass]="{
                      error:
                        conditionControl.get('text')?.get('operator')?.invalid &&
                        conditionControl.get('text')?.get('operator')?.touched,
                    }"
                  >
                    <mat-option value="contains">Contains</mat-option>
                    <mat-option value="equals">Equals</mat-option>
                    <mat-option value="starts_with">Starts with</mat-option>
                    <mat-option value="ends_with">Ends with</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="conditionControl.get('text')?.get('operator')?.invalid"
                  >
                    <small>
                      {{
                        conditionControl.get('text')!.get('operator')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
                <div class="form-group w-p20">
                  <div class="lum-label">Value</div>
                  <input
                    class="lum-input"
                    formControlName="value"
                    [ngClass]="{
                      error:
                        conditionControl.get('text')?.get('value')?.invalid &&
                        conditionControl.get('text')?.get('value')?.touched,
                    }"
                  />
                  <mat-error
                    *ngIf="conditionControl.get('text')?.get('value')?.invalid"
                  >
                    <small>
                      {{
                        conditionControl.get('text')!.get('value') | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
              </ng-container>

              <!-- Order Age Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.ORDER_AGE"
                formGroupName="orderAge"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    class="lum-select w-100"
                    formControlName="operator"
                    [ngClass]="{
                      error:
                        conditionControl.get('orderAge')?.get('operator')
                          ?.invalid &&
                        conditionControl.get('orderAge')?.get('operator')?.touched,
                    }"
                  >
                    <mat-option value="less_than">Less Than</mat-option>
                    <mat-option value="greater_than">Greater Than</mat-option>
                    <mat-option value="equals">Equals</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      conditionControl.get('orderAge')?.get('operator')?.invalid
                    "
                  >
                    <small>
                      {{
                        conditionControl.get('orderAge')!.get('operator')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
                <div class="form-group w-p20">
                  <div class="lum-label">Value (minutes)</div>
                  <input
                    class="lum-input"
                    formControlName="value"
                    [ngClass]="{
                      error:
                        conditionControl.get('orderAge')?.get('value')?.invalid &&
                        conditionControl.get('orderAge')?.get('value')?.touched,
                    }"
                  />
                  <mat-error
                    *ngIf="conditionControl.get('orderAge')?.get('value')?.invalid"
                  >
                    <small>
                      {{
                        conditionControl.get('orderAge')!.get('value')
                          | validateField
                      }}
                    </small>
                  </mat-error>
                </div>
              </ng-container>

              <!-- Order Status Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.ORDER_STATUS"
                formGroupName="orderStatus"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    formControlName="operator"
                    class="lum-select w-100"
                    [ngClass]="{
                      error:
                        conditionControl.get('orderStatus')?.get('operator')
                          ?.invalid &&
                        conditionControl.get('orderStatus')?.get('operator')
                          ?.touched,
                    }"
                  >
                    <mat-option value="{{ comparisonOperators.EQUAL }}">{{
                      comparisonOperatorsDisplay.EQUAL_TO
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.NOT_EQUAL }}">{{
                      comparisonOperatorsDisplay.NOT_EQUAL_TO
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.IN }}">{{
                      comparisonOperatorsDisplay.IN
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.NOT_IN }}">{{
                      comparisonOperatorsDisplay.NOT_IN
                    }}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      conditionControl.get('orderStatus')?.get('operator')?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('orderStatus')!.get('operator')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>
                <ng-container
                  *ngIf="
                    conditionControl.get('orderStatus')?.get('operator')?.value ===
                      comparisonOperators.IN ||
                      conditionControl.get('orderStatus')?.get('operator')
                        ?.value === comparisonOperators.NOT_IN;
                    else singleStatus
                  "
                >
                  <div class="form-group w-p40">
                    <div class="lum-label">Value</div>
                    <lum-ui-autocomplete-chip
                      placeholder="Search Status..."
                      [displayProperty]="'label'"
                      [options]="orderStatusOptions"
                      [selectedOptions]="
                        conditionControl.get('orderStatus')?.get('selected')
                          ?.value ?? []
                      "
                      [inlineChips]="true"
                      (optionSelectedEvent)="onAddStatus($event, i)"
                      (optionRemove)="onRemoveStatus($event, i)"
                    >
                    </lum-ui-autocomplete-chip>
                    <mat-error
                      *ngIf="
                        conditionControl.get('orderStatus')?.get('value')?.invalid
                      "
                    >
                      <small>{{
                        conditionControl.get('orderStatus')!.get('value')
                          | validateField
                      }}</small>
                    </mat-error>
                  </div>
                </ng-container>
                <ng-template #singleStatus>
                  <div class="form-group w-p20">
                    <div class="lum-label">Value</div>
                    <mat-select
                      formControlName="value"
                      class="lum-select w-100"
                      [ngClass]="{
                        error:
                          conditionControl.get('orderStatus')?.get('value')
                            ?.invalid &&
                          conditionControl.get('orderStatus')?.get('value')
                            ?.touched,
                      }"
                    >
                      <mat-option
                        *ngFor="
                          let orderStatus of orderStatuses;
                          trackBy: trackById
                        "
                        [value]="orderStatus.id"
                        >{{ orderStatus.name }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        conditionControl.get('orderStatus')?.get('value')?.invalid
                      "
                    >
                      <small>{{
                        conditionControl.get('orderStatus')!.get('value')
                          | validateField
                      }}</small>
                    </mat-error>
                  </div>
                </ng-template>
              </ng-container>

              <!-- Shipping Method Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.SHIPPING_METHOD"
                formGroupName="shippingMethod"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    formControlName="operator"
                    class="lum-select w-100"
                    [ngClass]="{
                      error:
                        conditionControl.get('shippingMethod')?.get('operator')
                          ?.invalid &&
                        conditionControl.get('shippingMethod')?.get('operator')
                          ?.touched,
                    }"
                  >
                    <mat-option value="{{ comparisonOperators.EQUAL }}">{{
                      comparisonOperatorsDisplay.EQUAL_TO
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.NOT_EQUAL }}">{{
                      comparisonOperatorsDisplay.NOT_EQUAL_TO
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.CONTAINS }}">{{
                      comparisonOperatorsDisplay.CONTAINS
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.STARTS_WITH }}">{{
                      comparisonOperatorsDisplay.STARTS_WITH
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.ENDS_WITH }}">{{
                      comparisonOperatorsDisplay.ENDS_WITH
                    }}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      conditionControl.get('shippingMethod')?.get('operator')
                        ?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('shippingMethod')!.get('operator')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>
                <div class="form-group w-p20">
                  <div class="lum-label">Value</div>
                  <input
                    formControlName="value"
                    class="lum-input"
                    [ngClass]="{
                      error:
                        conditionControl.get('shippingMethod')?.get('value')
                          ?.invalid &&
                        conditionControl.get('shippingMethod')?.get('value')
                          ?.touched,
                    }"
                  />
                  <mat-error
                    *ngIf="
                      conditionControl.get('shippingMethod')?.get('value')?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('shippingMethod')!.get('value')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>
              </ng-container>

              <!-- Product SKU Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.PRODUCT_SKU"
                formGroupName="productSku"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    formControlName="operator"
                    class="lum-select w-100"
                    [ngClass]="{
                      error:
                        conditionControl.get('productSku')?.get('operator')
                          ?.invalid &&
                        conditionControl.get('productSku')?.get('operator')
                          ?.touched,
                    }"
                  >
                    <mat-option value="{{ comparisonOperators.CONTAINS }}">{{
                      comparisonOperatorsDisplay.CONTAINS
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.NOT_CONTAINS }}">{{
                      comparisonOperatorsDisplay.NOT_CONTAINS
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.IN }}">{{
                      comparisonOperatorsDisplay.IN
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.NOT_IN }}">{{
                      comparisonOperatorsDisplay.NOT_IN
                    }}</mat-option>
                  </mat-select>
                </div>
                <div class="form-group w-p40">
                  <div class="lum-label">Value</div>
                  <lum-ui-autocomplete-chip
                    placeholder="Search SKU..."
                    [displayProperty]="'label'"
                    [options]="filteredRfqs"
                    [selectedOptions]="
                      conditionControl.get('productSku')?.get('selected')?.value ??
                      []
                    "
                    [inlineChips]="true"
                    (inputChangeEvent)="onSearchKeywordChange($event)"
                    (optionSelectedEvent)="onAddProduct($event, i)"
                    (optionRemove)="onRemoveProduct($event, i)"
                  >
                  </lum-ui-autocomplete-chip>
                  <mat-error
                    *ngIf="
                      conditionControl.get('productSku')?.get('value')?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('productSku')!.get('value')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>
              </ng-container>

              <!-- Order Total Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.ORDER_TOTAL"
                formGroupName="orderTotal"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    formControlName="operator"
                    class="lum-select w-100"
                    [ngClass]="{
                      error:
                        conditionControl.get('orderTotal')?.get('operator')
                          ?.invalid &&
                        conditionControl.get('orderTotal')?.get('operator')
                          ?.touched,
                    }"
                  >
                    <mat-option value="{{ comparisonOperators.GREATER_THAN }}">{{
                      comparisonOperatorsDisplay.GREATER_THAN
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.LESSER_THAN }}">{{
                      comparisonOperatorsDisplay.LESSER_THAN
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.EQUAL }}">{{
                      comparisonOperatorsDisplay.EQUAL_TO
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.NOT_EQUAL }}">{{
                      comparisonOperatorsDisplay.NOT_EQUAL_TO
                    }}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      conditionControl.get('orderTotal')?.get('operator')?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('orderTotal')!.get('operator')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>
                <div class="form-group w-p20">
                  <div class="lum-label">Value</div>
                  <input
                    type="number"
                    formControlName="value"
                    class="lum-input"
                    [ngClass]="{
                      error:
                        conditionControl.get('orderTotal')?.get('value')?.invalid &&
                        conditionControl.get('orderTotal')?.get('value')?.touched,
                    }"
                  />
                  <mat-error
                    *ngIf="
                      conditionControl.get('orderTotal')?.get('value')?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('orderTotal')!.get('value')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>
              </ng-container>

              <!-- Order Weight Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.ORDER_WEIGHT"
                formGroupName="orderWeight"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    formControlName="operator"
                    class="lum-select w-100"
                    [ngClass]="{
                      error:
                        conditionControl.get('orderWeight')?.get('operator')
                          ?.invalid &&
                        conditionControl.get('orderWeight')?.get('operator')
                          ?.touched,
                    }"
                  >
                    <mat-option value="{{ comparisonOperators.GREATER_THAN }}">{{
                      comparisonOperatorsDisplay.GREATER_THAN
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.LESSER_THAN }}">{{
                      comparisonOperatorsDisplay.LESSER_THAN
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.EQUAL }}">{{
                      comparisonOperatorsDisplay.EQUAL_TO
                    }}</mat-option>
                    <mat-option value="{{ comparisonOperators.NOT_EQUAL }}">{{
                      comparisonOperatorsDisplay.NOT_EQUAL_TO
                    }}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      conditionControl.get('orderWeight')?.get('operator')?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('orderWeight')!.get('operator')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>

                <ng-container formGroupName="value">
                  <div class="form-group w-p20">
                    <div class="lum-label">Weight Value</div>
                    <input
                      type="number"
                      formControlName="value"
                      class="lum-input"
                      [ngClass]="{
                        error:
                          conditionControl
                            .get('orderWeight')
                            ?.get('value')
                            ?.get('value')?.invalid &&
                          conditionControl
                            .get('orderWeight')
                            ?.get('value')
                            ?.get('value')?.touched,
                      }"
                    />
                    <mat-error
                      *ngIf="
                        conditionControl
                          .get('orderWeight')
                          ?.get('value')
                          ?.get('value').invalid
                      "
                    >
                      <small>{{
                        conditionControl
                          .get('orderWeight')!
                          .get('value')!
                          .get('value') | validateField
                      }}</small>
                    </mat-error>
                  </div>
                  <div class="form-group w-p20">
                    <div class="lum-label">Weight Unit</div>
                    <mat-select
                      formControlName="units"
                      class="lum-select w-100"
                      [ngClass]="{
                        error:
                          conditionControl
                            .get('orderWeight')
                            ?.get('value')
                            ?.get('units')?.invalid &&
                          conditionControl
                            .get('orderWeight')
                            ?.get('value')
                            ?.get('units')?.touched,
                      }"
                    >
                      <mat-option
                        *ngFor="
                          let weightUnit of weightUnits;
                          trackBy: trackByLabel
                        "
                        [value]="weightUnit.value"
                        >{{ weightUnit.label }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="
                        conditionControl
                          .get('orderWeight')
                          ?.get('value')
                          ?.get('units')?.invalid
                      "
                    >
                      <small>{{
                        conditionControl
                          .get('orderWeight')!
                          .get('value')!
                          .get('units') | validateField
                      }}</small>
                    </mat-error>
                  </div>
                </ng-container>
              </ng-container>

              <!-- Approval Status Condition -->
              <ng-container
                *ngSwitchCase="eAutomationRuleConditions.APPROVAL_STATUS"
                formGroupName="approvalStatus"
              >
                <input type="hidden" formControlName="type" />
                <div class="form-group w-p20">
                  <div class="lum-label">Operator</div>
                  <mat-select
                    formControlName="operator"
                    class="lum-select w-100"
                    [ngClass]="{
                      error:
                        conditionControl.get('approvalStatus')?.get('operator')
                          ?.invalid &&
                        conditionControl.get('approvalStatus')?.get('operator')
                          ?.touched,
                    }"
                  >
                    <mat-option value="{{ comparisonOperators.EQUAL }}">{{
                      comparisonOperatorsDisplay.EQUAL_TO
                    }}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      conditionControl.get('approvalStatus')?.get('operator')
                        ?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('approvalStatus')!.get('operator')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>

                <div class="form-group w-p20">
                  <div class="lum-label">Value</div>
                  <mat-select
                    formControlName="value"
                    class="lum-select w-100"
                    [ngClass]="{
                      error:
                        conditionControl.get('approvalStatus')?.get('value')
                          ?.invalid &&
                        conditionControl.get('approvalStatus')?.get('value')
                          ?.touched,
                    }"
                  >
                    <mat-option value="APPROVED">Approved</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      conditionControl.get('approvalStatus')?.get('value')?.invalid
                    "
                  >
                    <small>{{
                      conditionControl.get('approvalStatus')!.get('value')
                        | validateField
                    }}</small>
                  </mat-error>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <button
            (click)="onRemoveCondition(i)"
            mat-icon-button
            color="warn"
            type="button"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </form>

  <div class="flex justify-content-end mt-4">
    <button
      class="lum-button lum-button--secondary"
      type="button"
      (click)="onAddConditionRow(logicalOperators.AND)"
    >
      <lum-ui-icon class="mr-2" icon="add-1" color="#5563d6"></lum-ui-icon>
      Add Condition
    </button>
    <!-- <ng-template #addConditionWithOption>
      <button
        type="button"
        class="lum-button lum-button--secondary"
        [matMenuTriggerFor]="menu"
      >
        <lum-ui-icon class="mr-2" icon="add-1" color="#5563d6"></lum-ui-icon>
        Add Condition
      </button>
      <mat-menu class="lum-mat-menu" #menu="matMenu">
        <button mat-menu-item (click)="onAddConditionRow(logicalOperators.AND)">AND</button>
        <button mat-menu-item (click)="onAddConditionRow(logicalOperators.OR)">OR</button>
      </mat-menu>
    </ng-template> -->
  </div>
</div>
